// extracted by mini-css-extract-plugin
export default {"report":"Report_report__aJTbt","dark":"Report_dark__kp0bQ","light":"Report_light__lt3FM","top":"Report_top__QNRWh","bottom":"Report_bottom__O8uH6","icon":"Report_icon__Vkw66"};